
/* injects from baggage-loader */

import { queryBuilder } from '@lbs/swarm-client';

export const getSwarmSubscriptionRequestFavoriteCompetitions = () => {
    const builder = queryBuilder().useSource('betting');

    builder
        .selectSport(["id", "name", "alias", "order"])
        .selectCompetition(["id", "order", "name", "favorite_order"])
        .selectRegion(["id", "name", "alias", "order"])
        .whereCompetition('favorite').is(true);

    return builder.getParams();
};